import styled from "styled-components";

export const SignOutModalHeader = styled.span`
  font-size: 14px;
  color: #869094;
  margin-left: 30px;
  vertical-align: middle;
  font-weight: 400;
  .anticon {
    margin-right: 4px;
  }
`;
export const SignOutModalContent = styled.div`
  padding: 30px 20px 20px;
`;
export const SignOutModalInfo = styled.div`
  margin: 24px 83px 30px;
  border-bottom: 1px solid #3d4149;
  padding-bottom: 10px;
  .title,
  .tip {
    color: #979ca6;
    font-size: 12px;
    line-height: 22px;
  }
  .username,
  .phone {
    color: #d9dfe0;
    font-weight: 500;
    font-size: 16px;
    margin-top: 2px;
    line-height: 24px;
  }
  .tip {
    font-size: 14px;
    color: #d9dfe0;
  }
  .phone {
    font-size: 20px;
    line-height: 28px;
    margin-top: 10px;
  }
  .input-field {
    display: flex;
    flex-wrap: nowrap;
    margin-top: 14px;
    .ant-input {
      width: 247px;
      margin-right: 12px;
    }
    .renderbus-ui--input {
      border-radius: 4px;
      background: #191d1f;
      border-color: transparent;
    }
    .renderbus-ui--button {
      &.ant-btn.ant-btn-default,
      &:hover {
        background: transparent;
        color: var(--main-color) !important;
        border-color: var(--main-color) !important;
        height: 40px;
      }
    }
  }
  &.current-2 {
    border-bottom: none;
    margin-top: 40px;
  }
`;

export const SignOutModalRemark = styled.div`
  color: #d9dfe0;
  font-size: 14px;
`;
export const SignOutConfirmWrapper = styled.div`
  .confirm-text {
    margin-left: 8px;
    color: #d9dfe0;
  }
`;
export const SignOutReasonWrapper = styled.div`
  margin: 70px 154px 20px;
  &.abroad-style {
    margin: 70px auto 20px;
  }
  .ant-radio-group {
    margin-bottom: 20px;
    display: flex;
  }
  .renderbus-ui--input {
    height: 90px !important;
    border-radius: 4px;
    border-color: transparent;
  }
`;
export const ErrorWrapper = styled.div`
  color: rgb(255, 68, 68);
  margin-top: 4px;
`;
